import { useCallback } from "react"
import { IconGlobeOutline18 as Globe } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"
import { isValidIframeUrl } from "@productlane/lib/src/tiptap/extensions/iframe-extension"

import type {
	CustomBodyParams,
	SlashCommandCustomBodyElement,
	SlashCommandDefinition,
} from "../types"
import { toast } from "@/components/toast"
import { iconClassName } from "../constants"
import { UrlInput } from "./url-input"

type EmbedCustomProps = CustomBodyParams & {
	url?: string
}

const EmbedCommandBody: SlashCommandCustomBodyElement<EmbedCustomProps> = ({
	submit,
}) => {
	const onSubmit = useCallback(
		(url: string) => {
			if (!url) return
			if (!isValidIframeUrl(url)) {
				toast.error({
					title: "Invalid URL",
					description:
						"Please enter a valid HTTPS URL. Productlane domains cannot be embedded for security reasons.",
				})
				return
			}
			submit({ url })
		},
		[submit],
	)

	return (
		<UrlInput handleUrlSubmit={onSubmit} title="Embed URL" autoFocus={true} />
	)
}

export const embedCommand: SlashCommandDefinition<EmbedCustomProps> = {
	key: "embed",
	title: "Embed",
	bodyTitle: "Add Embed",
	icon: (
		<Globe
			className={cn(
				"h-[16px] w-[16px] stroke-[1.5] text-secondary",
				iconClassName,
			)}
		/>
	),
	command: ({ editor, range, customBodyParams }) => {
		if (!customBodyParams?.url) {
			editor.chain().focus().deleteRange(range)
			return
		}
		editor
			.chain()
			.focus()
			.deleteRange(range)
			.setIframe({ src: customBodyParams.url })
			.run()
	},
	customBody: EmbedCommandBody,
	group: "media",
	aliases: ["iframe", "website", "link"],
}
